<!--
 * @Author: your name
 * @Date: 2022-03-30 17:40:42
 * @LastEditTime: 2022-05-26 14:10:34
 * @LastEditors: Jokersora 674077946@qq.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \mingyao\src\views\About.vue
-->
<template>
  <div class="about">
    <div class="para">
      <div class="img company"></div>
      <div class="text">
        <div class="tit">我们的故事</div>
        <div class="txt">
          江苏明耀工程技术有限公司建于二零零七年七月初，坐落于江苏省苏州市工业园区凤里街345号2号楼C座，一家股份制性质的安装工程的有限责任公司，具有建筑机电安装工程专业承包贰级、消防设施工程专业承包贰级资质、建筑装饰装修工程专业承包贰级资质、电子与智能化工程专业承包贰级资质、特种工程专业承包（结构补强）资质、消防检测维保专项资质。本公司注册资金3600万元人民币，设有总经理室、工程部、市场部、财务部、售后服务部。现有在册员工50余人，其中高级工程师2人、工程师8人、助理工程师8人、一级建造师5人，二级建造师9人，经专业培训持有特种操作证的员工15人。大专以上学历者占员工总数的90%。
        </div>
      </div>
    </div>
    <div class="para">
      <div class="img reward"></div>
      <div class="text">
        <div class="tit">我们的荣誉</div>
        <div class="txt">
          本公司经营稳健，恪守信用，技术力量雄厚。已通过ISO9001质量体系认证，公司资信等级AAA级，被评为“质量安全科技创新，全面管理优秀示范单位”，获得了“全国工程质量施工安全企业信誉AAA级优秀企业”等荣誉称号，获得了“扬子杯”、“姑苏杯”、“天堂杯”等多项殊荣，在江苏省建筑市场上享有较高的声誉。公司坚持科技兴企，成立了“科技研发中心”，拥有国家级发明专利1项，国家级实用新型专利8项，省级工法5项。
        </div>
      </div>
    </div>
    <div class="para">
      <div class="img jyfw"></div>
      <div class="text">
        <div class="tit">我们的经营范围</div>
        <div class="txt">
        本公司经营范围：承接各类建筑机电安装工程、消防工程、建筑装饰装修工程、电子与智能化系统工程、暖通中央空调工程、专业深耕洁净无尘室行业：主要采用EPC模式，对生物医药、半导体、电子、食品、室验和检测室、新型材料等净化行业，从设计、施工到维保提供全产业链服务，工艺、废气废水处理系统安装、压缩空气和气体供应系统安装、化工医药行业特种设备及压力管道工程、医院手术室净化及医用气体工程安装、污水处理设备及管道安装、环保设备及管道安装。 
        </div>
      </div>
    </div>
    <div class="para">
      <div class="img kh"></div>
      <div class="text">
        <div class="tit">我们的客户</div>
        <div class="txt">
          目前已与代表性工业客户：奇美集团、富士康集团、正隆集团、六和集团、英诺赛克半导体、苏州步步高互联网软件、南通阳鸿石化、泰兴省级化工园区、苏州博众精工科技、宝时得科技、江苏宜美科技无尘室厂房、尚宝泰机械、苏州赛众、南海奇美、济川药业、长澳制药、海纳制药、焦点生物、瑞邦生物科技、米巴精密零部件、安特精密机械技术、巨翊医疗科技、优泰克、苏州新纶超净技术、苏瑞膜纳米、台容电子、泰马克精密铸造、泰州龙洋智能科技；代表性民用公建客户：苏高新集团、苏高新股价、苏州城投公司、苏州保泽公司、园区新建元集团、园区重建公司、园区恒泰集团、相城城投公司、吴中城建公司、远洋地产、保利地产、金地地产；代表性总承包单位：中建一、三、四、八局、江苏永泰、南通光华、南通新华、中亿丰、苏州一建、嘉盛建设、通州建总等公司建立了长期合作关系。我们将以专业的技术、真诚的态度为相关单位提供优质周到的服务。
        </div>
      </div>
    </div>
    <div class="para">
      <div class="img bussiness"></div>
      <div class="text">
        <div class="tit">我们的企业文化</div>
        <div class="txt">
          公司以“质量为本 科学公正 客户至上 服务规范”为经营理念。本着“科学、准确、公正、及时”为原则服务于社会，受到客户的一致好评。我们本着“信誉至上，互惠互利”的原则，热忱欢迎新老客户前来洽谈业务，携手合作，共创辉煌。
        </div>
      </div>
    </div>
      <img class="yyzz" :src="require('../assets/images/yyzz.jpg')" />
    <Root />
  </div>
</template>

<script>
import Root from '@/components/Root.vue'
export default {
  name: "About",
  components:{
    Root
  }
};
</script>

<style lang="less" scoped>
.para:nth-child(2n + 1) {
  .img,
  .text {
    float: left;
  }
}
.para:nth-child(2n) {
  .img,
  .text {
    float: right;
  }
}
.img{
  background-size: contain;
}
.kh{
  background-image:url(../assets/images/kh.jpg);
}
.reward{
  background-image:url(../assets/images/reward.jpg);
}
.jyfw{
  background-image:url(../assets/images/jyfw.jpg);
}
.bussiness{
  background-image:url(../assets/images/bussiness.jpg);
}
.company{
  background-image:url(../assets/images/company.jpg);
}
.para {
  padding: 1rem 20% 1rem 20%;
  display: inline-block;
  .img,
  .text {
    width: 50%;
    height: 25rem;
  }
  .text {
    padding: 1rem;
    text-align: left;
    .tit {
      font-size: 1.5rem;
      color: rgb(27, 151, 243);
      border-left: 5px solid rgb(27, 151, 243);
      padding-left: 0.5rem;
      font-weight: bold;
    }
    .txt {
      color: rgb(100, 100, 100);
      font-size: 0.9rem;
      line-height: 2rem;
      padding-top: 1rem;
    }
  }
}
.yyzz{
  width:100%;
}
</style>